// John Eldhose 20180627
const ShoppingCart = (state = {}, action) => {
  var newState = {};
  switch (action.type) {
    case 'ADD_TO_CART':
      newState = Object.assign({}, state);
      newState[action.item.SERIALNUM] = action.item;
      return newState;
    case 'REMOVE_FROM_CART':
      if(typeof state[action.item] !== 'undefined') {
        newState = Object.assign({}, state);
        delete newState[action.item];
        return newState;
      }
      break;
    case 'RESET_CART':
      return newState;
    default:
  }
  return state;
};

export default ShoppingCart;



// WEBPACK FOOTER //
// ./src/reducers/ShoppingCart.js